import { TaxForms } from '../../../investment/components/documents/TaxForms';

export default function TaxFormsPage() {
    return <TaxForms />;
}
